import {
  CompanyOfSearchModal,
  RouteOfSearchModal,
} from '@doda/common/src/models/MasterCacheModel';

import {
  StationResponse,
  JobCountResponse,
  JobCountDetailResponse,
} from '@doda/api-client/aspida/@types';

/**
 * 表示用の鉄道会社データを定義するインターフェース
 */
export interface DisplayRailwayCompany extends CompanyOfSearchModal {
  /** 路線のリスト */
  routeList: DisplayRoute[];
}

/**
 * 表示用の路線データを定義するインターフェース
 */
export interface DisplayRoute extends RouteOfSearchModal {
  /** 駅のリスト */
  stationList: DisplayStation[];
  /** 求人数（オプション） */
  jobCount?: number;
}

/**
 *表示用の駅データを定義するインターフェース
 */
export interface DisplayStation extends StationResponse {
  /** 求人数（オプション） */
  jobCount?: number;
}

/**
 * 表示用路線・駅一覧を作成する関数
 *
 * @param {CompanyOfSearchModal[]} routeMasterData - 路線マスターデータ
 * @param {JobCountResponse} jobCount - 求人件数のレスポンス
 * @returns {DisplayRailwayCompany[]} - 表示用の鉄道会社データ
 */
export const createDisplayStation = (
  routeMasterData: CompanyOfSearchModal[],
  jobCount: JobCountResponse
): DisplayRailwayCompany[] => {
  return routeMasterData.map((railwayCompany) => ({
    ...railwayCompany,
    routeList: railwayCompany.routeList.map((route) => ({
      ...route,
      jobCount: findJobCount(jobCount.routeList, route.id),
      stationList: route.stationList.map((station) => ({
        ...station,
        jobCount: findJobCount(jobCount.stationList, station.id),
      })),
    })),
  }));
};

/**
 * 求人数を探す関数
 *
 * @param {JobCountDetailResponse[] | undefined} countList - 求人件数の詳細リスト
 * @param {string} id - 探しているID
 * @returns {number} - 見つかった求人件数
 */
export const findJobCount = (
  countList: JobCountDetailResponse[] | undefined,
  id: string
): number => countList?.find((i) => id === i.id)?.count ?? 0;
